export enum CplRequirement {
    OPTIONAL = 0,
    REQUIRED = 1,
    NONE = 2
}